// extracted by mini-css-extract-plugin
export default {"navbar":"main_navbar__lYLxu","smilespage":"main_smilespage__YT3nd"};